import { c as _c } from "react/compiler-runtime";
import type { TagGeneralSkillLevel } from '@algoacademy/backend/modules/tag/enums';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { H2 } from '@algoacademy/design-system/web/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph';
import { SkillBadge } from '@/app/(marketing-site)/(portfolio)/_components/SkillBadge';
type EducationItem = {
  institution: string;
  degree: string;
  description: string;
  skills: {
    name: string;
    level: TagGeneralSkillLevel;
  }[];
  from: string;
  to?: string | null;
};
type EducationProps = {
  education: EducationItem[];
};
function EducationItem(t0) {
  const $ = _c(21);
  const {
    education
  } = t0;
  const t1 = education.to ?? "obecnie";
  let t2;
  if ($[0] !== education.from || $[1] !== t1) {
    t2 = <P2 className="text-nowrap text-contentTertiary lg:w-28 lg:shrink-0">{education.from} - {t1}</P2>;
    $[0] = education.from;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== education.degree) {
    t3 = <P2 className="font-bold text-contentPrimary">{education.degree}</P2>;
    $[3] = education.degree;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== education.institution) {
    t4 = <P2 className="font-medium text-contentSecondary">{education.institution}</P2>;
    $[5] = education.institution;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex flex-row flex-wrap gap-2 align-start">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== education.description) {
    t6 = <P2 className="text-contentSecondary">{education.description}</P2>;
    $[10] = education.description;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== education.skills) {
    t7 = education.skills && education.skills.length > 0 && <div className="flex flex-row flex-wrap gap-3">{education.skills.map(_temp)}</div>;
    $[12] = education.skills;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="min-w-0 space-y-3">{t5}{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t8) {
    t9 = <div className="flex flex-col items-start gap-4 lg:flex-row lg:gap-5">{t2}{t8}</div>;
    $[18] = t2;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function _temp(skill) {
  return <SkillBadge key={skill.name} skill={skill.name} />;
}
export function Education(t0) {
  const $ = _c(5);
  const {
    education
  } = t0;
  if (!education || education.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H2>Edukacja</H2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== education) {
    t2 = education.map(_temp2);
    $[1] = education;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <LightCard className="max-w-5xl space-y-8 shadow-sm">{t1}<div className="space-y-10">{t2}</div></LightCard>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp2(educationItem) {
  return <EducationItem key={`${educationItem.institution}-${educationItem.degree}`} education={educationItem} />;
}